import '../vendor/air-datepicker/air-datepicker'

var currentIndex = 0;

$('.js-datepickersFromAndTo').each(function() {
  var _this = $(this);
  var classDatepickerFrom = `js-datepickerFrom-${currentIndex}`;
  var classDatepickerTo = `js-datepickerTo-${currentIndex}`;
  var containerDatepickerFrom = `js-datepickerFromContainer-${currentIndex}`;
  var containerDatepickerTo = `js-datepickerToContainer-${currentIndex}`;

  _this.find('.js-datepickerFrom').addClass(classDatepickerFrom);
  _this.find('.js-datepickerTo').addClass(classDatepickerTo);
  _this.find('.js-datepickerFrom').parent().addClass(containerDatepickerFrom);
  _this.find('.js-datepickerTo').parent().addClass(containerDatepickerTo);

  var $start = $(`.js-datepickerFrom-${currentIndex}`)
  var $startContainer = $(`.js-datepickerFromContainer-${currentIndex}`)
  var $end = $(`.js-datepickerTo-${currentIndex}`)
  var $endContainer = $(`.js-datepickerToContainer-${currentIndex}`)

  $(document).on('click', function(event) {
    if ($(event.target).hasClass('datepicker--cell datepicker--cell-day')) {
      $startContainer.find('.datepicker').css({'display': 'none'})
      $endContainer.find('.datepicker').css({'display': 'none'})
    }
  })

  $start.click(function () {
    $startContainer.find('.datepicker').css({'display': 'block'})
    $endContainer.find('.datepicker').css({'display': 'none'})
  })

  $end.click(function () {
    $endContainer.find('.datepicker').css({'display': 'block'})
    $startContainer.find('.datepicker').css({'display': 'none'})
  })

  $start.datepicker({
    inline: true,
    onSelect: function (fd, date) {
      $end.data('datepicker')
        .update('minDate', date)
    }
  })

  $end.datepicker({
    inline: true,
    onSelect: function (fd, date) {
      $start.data('datepicker')
        .update('maxDate', date)
    }
  })

  currentIndex++;
});
